import React from 'react';
import Modal, { ModalProps } from '~/App/Components/Modal';
import { StyleableProps } from '~/App/Components/HOC/Styleable';
import styled from '@emotion/styled';
import colours from '~/utils/colours';
import Button from '~/App/Components/Button';
import { assetUrl } from '~/helpers';
import { ContentBlockModalType } from '../../Types';

const styles: StyleableProps = {
  panel: ({ base }) => ({
    ...base,
    maxWidth: '455px',
    padding: '30px 53px 30px 44px',
  }),
  content: ({ base }) => ({
    ...base,
    maxWidth: '455px',
    padding: '0',
    marginTop: '190px',
  }),
};

const Title = styled.h2`
  color: ${colours.greyDarkAlt2};
  margin-bottom: 25px;
  text-align: center;
`;

const Body = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    width: 45%;
  }
`;

const SelectionWrapper = styled.div`
  text-align: center;
`;

const SelectionText = styled.p`
  color: ${colours.greyDarkAlt3};
  margin-bottom: 10px;
`;

const Image = styled.img`
  display: block;
  margin: 0 auto 10px;
`;

const SelectionTitle = styled.span`
  color: ${colours.textDark};
  font-weight: 700;
`;

interface ContentBlockSelectionProps {
  imgSrc: string;
  title: string;
  desc: string;
  btnStyle: string;
  btnText: string;
  onBtnClick: () => void;
}

const ContentBlockSelection = ({
  imgSrc,
  title,
  desc,
  btnStyle,
  btnText,
  onBtnClick,
}: ContentBlockSelectionProps) => {
  return (
    <SelectionWrapper>
      <Image src={imgSrc} />
      <SelectionTitle>{title}</SelectionTitle>
      <SelectionText>{desc}</SelectionText>
      <Button block bsStyle={btnStyle} onClick={onBtnClick}>
        {btnText}
      </Button>
    </SelectionWrapper>
  );
};

export interface ChooseContentBlockProps extends ModalProps {
  onContentBlockSelected: (selectedContentBlock: ContentBlockModalType) => void;
}

const ChooseContentBlock = ({
  onContentBlockSelected,
  ...modalProps
}: ChooseContentBlockProps) => {
  return (
    <Modal {...{ styles, ...modalProps }}>
      <Title>
        Choose the content block you would like to add to your template.
      </Title>
      <Body>
        <ContentBlockSelection
          imgSrc={assetUrl('assets/images/message-template/AddVideo.svg')}
          title='Video sequence'
          desc='Add a video uploaded or recorded from your Bonjoro My Library.'
          btnStyle='important'
          btnText='Add video'
          onBtnClick={() =>
            onContentBlockSelected(ContentBlockModalType.VideoLibrary)
          }
        />
        <ContentBlockSelection
          imgSrc={assetUrl('assets/images/message-template/Embed.svg')}
          title='Embed content'
          desc='Embed content from your favourite tools in any order you like.'
          btnStyle='primary'
          btnText='Add embed'
          onBtnClick={() =>
            onContentBlockSelected(ContentBlockModalType.MediaEmbed)
          }
        />
      </Body>
    </Modal>
  );
};

export default ChooseContentBlock;
